import { GoogleCalendarIcon } from '@systemeio/ui/icons'
import { Modal } from '@systemeio/ui'
import { ConnectInfoIntegration } from 'modules/profile/integrations/components/connect-info-integration'
import { WrapperIntegration } from 'modules/profile/integrations/components/wrapper-integration'
import { WrapperIntegrationSkeleton } from 'modules/profile/integrations/components/wrapper-integtation-skeleton'
import { useGoogleIntegrations } from 'modules/profile/integrations/google/hooks/use-google-integrations'
import { useIntegrateGoogle } from 'modules/profile/integrations/google/hooks/use-integrate-google'
import {
  IntegrationInterface,
  IntegrationUseCaseEnum,
} from 'modules/profile/integrations/google/types'
import React from 'react'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules'
import { GoogleCalendarConfiguration } from './calendar-configuration'
import { getHelpPageLinkGoogleCalendar } from '../utils/get-help-page-link-google-calendar'

export const GoogleCalendarIntegrationComingSoon = () => {
  const { t } = useLocoTranslation()
  return (
    <WrapperIntegration
      icon={<GoogleCalendarIcon />}
      title={t('dashboard.user_settings.integrations_page.google_calendar.name')}
      subTitle={t('dashboard.user_settings.integrations_page.google_calendar.subtitle')}
      isComingSoon
    />
  )
}

export const GoogleCalendarIntegration = ({
  opened,
  setOpened,
}: {
  opened: boolean
  setOpened: (opened: boolean) => void
}) => {
  const { t } = useLocoTranslation()

  const { openGoogleLogin, openGoogleLoginToReconnect, isFetching } = useIntegrateGoogle({
    onSuccess: handleIntegrationSuccess,
  })
  const { revalidateModules } = useRevalidateModules()
  const { getIntegrationsByUseCase, mutateIntegrationsWithNewItem } = useGoogleIntegrations()
  const data = getIntegrationsByUseCase(IntegrationUseCaseEnum.Calendar)

  async function handleIntegrationSuccess(item: IntegrationInterface) {
    await mutateIntegrationsWithNewItem(item)
    await revalidateModules([RequestModuleEnum.GoogleIntegrationsCalendars], true)
  }

  async function openLogin() {
    await openGoogleLogin(IntegrationUseCaseEnum.Calendar)
  }

  async function openReconnect(id: IntegrationInterface['id'], preselectedEmail?: string) {
    await openGoogleLoginToReconnect(id, preselectedEmail)
  }

  const isConnected = data?.items.some(integration => !integration.disconnectedAt) ?? false

  const hasIntegrations = data?.items.length !== 0

  if (!data) return <WrapperIntegrationSkeleton />

  return (
    <>
      <WrapperIntegration
        icon={<GoogleCalendarIcon />}
        title={t('dashboard.user_settings.integrations_page.google_calendar.name')}
        subTitle={t('dashboard.user_settings.integrations_page.google_calendar.subtitle')}
        onClick={() => setOpened(true)}
        isConnect={isConnected}
      />
      <Modal
        title={t('dashboard.user_settings.integrations_page.google_calendar.title')}
        onClose={() => setOpened(false)}
        opened={opened}
      >
        <>
          {hasIntegrations ? (
            <GoogleCalendarConfiguration onAddAccount={openLogin} onReconnect={openReconnect} />
          ) : (
            <ConnectInfoIntegration
              isFetching={isFetching}
              href={getHelpPageLinkGoogleCalendar()}
              handleOpenIntegrationLogin={openLogin}
              infoText={
                'dashboard.user_settings.integrations_page.google_calendar_integration.help'
              }
            />
          )}
        </>
      </Modal>
    </>
  )
}
